<template>
  <b-card>

    <!-- search input -->
    <b-row class="mb-1">
      <b-col lg="4">
        <b-form-input
          v-model.lazy="searchTerm"
          placeholder="Search..."
          type="text"
          class="d-inline-block mr-sm-1 mb-1 mb-sm-0"
          @keyup="onSearch"
        />
      </b-col>
      <b-col
        lg="8"
        class="d-flex justify-content-end align-items-center"
      >
        <template v-if="$permissionAbility(DIVISION_CREATE, permissions)">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            class="flex-shrink-0 mr-1"
            variant="primary"
            @click="showModal"
          >
            Create Division
          </b-button>
        </template>
        <template
            v-if="$permissionAbility(DIVISION_TRASH_ACCESS, permissions)"
        >
          <b-button
              class="flex-shrink-0"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="warning"
              @click="goToTrash"
          >
            Archives
          </b-button>
        </template>
      </b-col>
    </b-row>

    <!-- table -->
    <vue-good-table
      mode="remote"
      :total-rows="totalRecords"
      :is-loading.sync="isLoading"
      :rows="rows"
      :sort-options="{
        enabled: false,
        multipleColumns: true,
        initialSortBy: [
          { field: 'id', type: 'desc' },
          { field: 'name', type: 'desc' },
          { field: 'created_at', type: 'desc' },
        ],
      }"
      :columns="columns"
      :pagination-options="{
        enabled: true,
        perPage: pageLength,
      }"
      @on-page-change="onPageChange"
      style-class="vgt-table striped"
      @on-sort-change="onSortChange"
      @on-column-filter="onColumnFilter"
      @on-per-page-change="onPerPageChange"
    >
      >
      <template
        slot="table-row"
        slot-scope="props"
      >
        <!-- Column: head -->
        <span v-if="props.column.field === 'head_user'">
          <template v-if="props?.row?.head_id != null">

            <UserCard :user="props?.row?.head?.data" />

          </template>
          <template v-else>
            <b-badge variant="light-danger">
              Not Assigned
            </b-badge>
          </template>

          <!-- <template v-if="props?.row?.head_id != null">
              <b-avatar :src="props?.row?.head?.data?.avatar" class="mr-1" />
              <span class="text-nowrap">{{
                props?.row?.head?.data?.name
              }}</span>
            </template> -->
        </span>

        <!-- <span>
              <b-dropdown
                variant="link"
                toggle-class="text-decoration-none"
                no-caret
              >
                <template v-slot:button-content>
                  <feather-icon
                    icon="MoreVerticalIcon"
                    size="16"
                    class="text-body align-middle mr-25"
                  />
                </template>
                <template v-if="$permissionAbility(DIVISION_EDIT, permissions)">
                  <b-dropdown-item v-on:click="onShow(props.row)">
                    <feather-icon icon="Edit2Icon" class="mr-50" />
                    <span>Edit</span>
                  </b-dropdown-item>
                </template>

                <template
                  v-if="$permissionAbility(DIVISION_DELETE, permissions)"
                >
                  <b-dropdown-item v-on:click="onDelete(props.row)">
                    <feather-icon icon="TrashIcon" class="mr-50" />
                    <span>Delete</span>
                  </b-dropdown-item>
                </template>
              </b-dropdown>
            </span> -->

        <span v-if="props.column.field === 'format_departments_count'">
          <b-badge
            class="ml-4"
            variant="light-primary"
          >
            {{ props?.row?.departments_count }}
          </b-badge>
        </span>

        <span v-if="props.column.field === 'action'">

          <template v-if="$permissionAbility(DIVISION_EDIT, permissions)">
            <span @click="onShow(props.row)">
              <feather-icon
                v-b-tooltip.hover
                icon="Edit2Icon"
                class="mr-50 custom-icon cursor-pointer"
                title="Edit"
                size="16"
              />
            </span>
          </template>

          <template
            v-if="$permissionAbility(DIVISION_DELETE, permissions)"
          >
            <span @click="onDelete(props.row)">
              <feather-icon
                v-b-tooltip.hover
                icon="TrashIcon"
                class="mr-50 custom-icon cursor-pointer"
                title="Delete"
                size="16"
              />
            </span>
          </template>

        </span>

        <!-- Column: Common -->
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>

      <!-- pagination -->
      <template
        slot="pagination-bottom"
        slot-scope="props"
      >
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap"> Showing 1 to </span>
            <b-form-select
              v-model="pageLength"
              :options="['10', '25', '50', '100', '500']"
              class="mx-1"
              @input="
                (value) => props.perPageChanged({ currentPerPage: value })
              "
            />
            <span class="text-nowrap"> of {{ props.total }} entries </span>
          </div>
          <div>
            <b-pagination
              :value="1"
              :total-rows="props.total"
              :per-page="pageLength"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @input="(value) => props.pageChanged({ currentPage: value })"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>
          </div>
        </div>
      </template>
    </vue-good-table>

    <b-modal
      id="modal-division-form"
      centered
      :title="modelType == 'editModel' ? 'Edit' : 'Create'"
      hide-footer
      no-close-on-backdrop
      @hidden="hiddenModal"
    >
      <validation-observer ref="divisionValidation">
        <b-form @submit.prevent="validationForm">
          <!-- name -->
          <b-form-group
            label="Name"
            label-for="name"
            class="required-label"
          >
            <validation-provider
              #default="{ errors }"
              name="name"
              vid="name"
              rules="required|max:255"
            >
              <b-form-input
                id="name"
                v-model="name"
                type="text"
                :state="errors.length > 0 ? false : null"
                placeholder="Division"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>

          <!-- select head-->
          <b-form-group
            label="Head"
            label-for="head-id"
          >
            <ValidationProvider
              v-slot="{ errors }"
              name="head_id"
              vid="head_id"
            >
              <v-select
                id="head-id"
                v-model="selectHeadId"
                placeholder="Choose a Head"
                :options="headIdOption"
                :reduce="(country) => country.id"
                label="name"
              >
                <template #option="data">
                  <UserSelect :user="data" />
                </template>
              </v-select>
              <small class="text-danger">{{ errors[0] }}</small>
            </ValidationProvider>
          </b-form-group>

          <!-- loading button -->
          <template v-if="isDivisionFormSubmitLoading">
            <b-button
              class="float-right"
              variant="primary"
              disabled
            >
              <b-spinner small />
              Loading...
            </b-button>
          </template>

          <!-- submit button -->
          <template v-else>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              type="submit"
              class="float-right"
              variant="primary"
            >
              Submit
            </b-button>
          </template>
        </b-form>
      </validation-observer>
    </b-modal>
  </b-card>
</template>

<script>
import {
  BCard,
  BAvatar,
  BBadge,
  BPagination,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BDropdown,
  BDropdownItem,
  BButton,
  BForm,
  BModal,
  BSpinner, VBTooltip, BRow, BCol,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import Ripple from 'vue-ripple-directive'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, max } from '@validations'

import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { mapGetters } from 'vuex'
import {
  DIVISION_CREATE,
  DIVISION_EDIT,
  DIVISION_DELETE,
  DIVISION_TRASH_ACCESS,
} from '@/helpers/permissionsConstant'
import UserCard from '@/layouts/components/UserCard.vue'
import UserSelect from '@/layouts/components/UserSelect.vue'

export default {
  name: 'DivisionView',
  components: {
    BCol,
    BRow,
    BForm,
    BButton,
    BCard,
    VueGoodTable,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    ValidationProvider,
    ValidationObserver,
    BModal,
    BSpinner,
    UserCard,
    UserSelect,
  },
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
  },
  data() {
    return {
      DIVISION_CREATE,
      DIVISION_EDIT,
      DIVISION_DELETE,
      DIVISION_TRASH_ACCESS,
      modelType: '',
      divisionId: '',
      name: '',
      selectHeadId: '',
      headIdOption: [],
      pageLength: 10,
      columns: [
        {
          label: 'Name',
          field: 'name',
        },
        {
          label: 'Division Head',
          field: 'head_user',
          sortable: false,
        },
        {
          label: 'No. of Departments',
          field: 'format_departments_count',
          sortable: false,
        },
        {
          label: 'Action',
          field: 'action',
          sortable: false,
        },
      ],
      rows: [],
      searchTerm: '',
      delayTimer: null,
      isLoading: false,
      isDivisionFormSubmitLoading: false,
      totalRecords: 0,
      serverParams: {
        columnFilters: {},
        sort: [
          { field: 'id', type: 'desc' },
          { field: 'name', type: 'desc' },
          { field: 'created_at', type: 'desc' },
        ],
        page: 1,
        perPage: 10,
      },
    }
  },

  computed: {
    ...mapGetters({
      permissions: 'userModule/getPermissions',
    }),
  },

  async created() {
    try {
      const [users] = await Promise.all([this.getUsers()])

      this.headIdOption = (users?.data?.data || []).map(item => ({
        avatar: item?.avatar,
        name: item?.name,
        email: item?.email,
        mobile: item?.mobile,
        employee_number: item?.employee_number,
        id: item?.id,
        departmentId: item?.department_id,
      }))
      
    } catch (error) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Error',
          icon: 'BellIcon',
          variant: 'danger',
          text: error?.response?.data?.message,
        },
      })
    }
  },

  methods: {
    showModal() {
      this.$bvModal.show('modal-division-form')
    },
    hiddenModal() {
      this.modelType = ''
      this.$bvModal.hide('modal-division-form')
      this.resetModal()
    },
    resetModal() {
      this.name = ''
      this.selectHeadId = ''
    },
    async onShow(value) {
      this.modelType = 'editModel'
      this.name = value.name
      this.divisionId = value.id
      this.selectHeadId = value.head_id

      this.showModal()
    },
    async onDelete(row) {
      this.$swal({
        title: 'Warning!',
        text: `Are You Sure You Want To Delete ${row.name}?`,
        icon: 'warning',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: 'Ok',
        showLoaderOnConfirm: true,
      }).then(async result => {
        if (result.isConfirmed) {
          try {
            await this.$api.delete(`/api/divisions/${row.id}`)

            this.loadItems()

            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Success',
                icon: 'BellIcon',
                variant: 'success',
                text: 'Moved to Archive Successfully',
              },
            })
          } catch (error) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Error',
                icon: 'BellIcon',
                variant: 'danger',
                text: error?.response?.data?.message,
              },
            })
          }
        }
      })
    },

    onSearch() {
      if (this.delayTimer) {
        clearTimeout(this.delayTimer)
        this.delayTimer = null
      }

      this.delayTimer = setTimeout(() => {
        this.loadItems()
      }, 1000)
    },

    updateParams(newProps) {
      this.serverParams = { ...this.serverParams, ...newProps }
    },

    onPageChange(params) {
      this.updateParams({ page: params.currentPage })
      this.loadItems()
    },

    onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage })
      this.loadItems()
    },

    onSortChange(params) {
      this.updateParams({
        sort: params,
      })
      this.loadItems()
    },

    onColumnFilter(params) {
      this.updateParams(params)
      this.loadItems()
    },
    goToTrash() {
      this.$router.push({ name: 'admin-division-trash' })
    },
    async getDivisions(params) {
      return await this.$api.get('api/divisions?include=head', {
        params: {
          show: params.show,
          page: params.page,
          sort: params.sort,
          q: params.q,
        },
      })
    },
    async getUsers() {
      return await this.$api.get('api/users/all?include=designation')
    },

    async loadItems() {
      try {
        const [divisions] = await Promise.all([
          this.getDivisions({
            show: this.serverParams.perPage,
            page: this.serverParams.page,
            sort: this.serverParams.sort,
            q: this.searchTerm,
          }),
        ])

        const data = divisions?.data?.data

        console.log(data)
        const meta = divisions?.data?.meta

        this.totalRecords = meta?.pagination?.total
        this.rows = data
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Warning',
            icon: 'BellIcon',
            variant: 'warning',
            text: error?.response?.data?.message,
          },
        })
      }
    },
    async validationForm() {
      this.$refs.divisionValidation.validate().then(async success => {
        if (success) {
          try {
            if (this.modelType == 'editModel') {
              this.isDivisionFormSubmitLoading = true
              await this.$api.put(`/api/divisions/${this.divisionId}`, {
                name: this.name,
                head_id: this.selectHeadId,
              })
              this.isDivisionFormSubmitLoading = false
              this.loadItems()
              this.hiddenModal()
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Success',
                  icon: 'BellIcon',
                  variant: 'success',
                  text: 'Successfully Updated',
                },
              })
            } else {
              this.isDivisionFormSubmitLoading = true
              await this.$api.post(
                '/api/divisions',

                {
                  name: this.name,
                  head_id: this.selectHeadId,
                },
              )
              this.isDivisionFormSubmitLoading = false
              this.hiddenModal()

              this.loadItems()

              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Success',
                  icon: 'BellIcon',
                  variant: 'success',
                  text: 'Successfully Created',
                },
              })
            }
          } catch (error) {
            this.isDivisionFormSubmitLoading = false
            if (error?.response?.data?.message) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Error',
                  icon: 'BellIcon',
                  variant: 'danger',
                  text: error?.response?.data?.message,
                },
              })
            }

            if (error?.response?.data?.errors) {
              this.$refs.divisionValidation.setErrors(
                error?.response?.data?.errors,
              )
            }
          }
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";

.required-label label::after {
  content: " *";
  color: red;
}

.actionBtn span{
  padding: 8px;
  margin: 1px;
  cursor: pointer;
}
</style>
